import search from './filtersToSearch'

export const filtersToSearch = ({ filters }) => search({...filters})

export const agendas = ({ agendas }) => agendas

export const filters = ({ filters }) => filters

export const loading = ({ loading }) => loading

export const searchedBy = ({ searchedBy }) => searchedBy

export const pagination = ({ pagination }) => pagination

export const filtersToSearchIsEmpty = ({ filters }) => {
  const aux = {...filtersToSearch({filters: filters})}
  delete aux.page
  delete aux.limit

  return Object.keys(aux).length < 1
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/store/getters/index.js